<template>
  <article :class="wrapClass">
    <div class="cursor cursor--small"></div>
    <canvas class="cursor cursor--canvas" resize></canvas>
    <header class="people-header">
      <div class="section-wrap">
        <Header :trigger="trigger"/>
      </div>
      <ul class="people-page">
        <li :class="`people-page__person people-page__person--one ${active == 0 ? 'people-page__person--active' : ''} ${active == 2 ? 'people-page__person--forwards' : 'people-page__person--backwards'}`">
          <div class="people-page__person__element people-page__person__element--secondary" :style="{backgroundImage: `url(${frede2})`}"></div>
          <div class="people-page__person__element people-page__person__element--main" :style="{backgroundImage: `url(${frede1})`}"></div>
          <div class="people-page__person__element people-page__person__element--tertiary" :style="{backgroundImage: `url(${frede3})`}"></div>
          <div class="people-page__person__element people-page__person__element--quaternary" :style="{backgroundImage: `url(${frede3})`}"></div>
          <h1 class="people-page__person__element people-page__person__element--name">
            frederik
            <span class="people-page__person__element--name__inner">frederik</span>
            <span class="people-page__person__element--name__inner">frederik</span>
            <span class="people-page__person__element--name__inner">frederik</span>
          </h1>
          <div class="people-page__person__element people-page__person__element--content">
            <h2 class="people-page__person__title">developer</h2>
            <p class="people-page__person__description">react and Vue developer, who loves to be challenged and work with cutting-edge technology within the browser</p>
          </div>
        </li>
        <li :class="`people-page__person people-page__person--two ${active == 1 ? 'people-page__person--active' : ''} ${active < 1 ? 'people-page__person--forwards' : 'people-page__person--backwards'}`">
          <div class="people-page__person__element people-page__person__element--secondary" :style="{backgroundImage: `url(${aleksis2})`}"></div>
          <div class="people-page__person__element people-page__person__element--main" :style="{backgroundImage: `url(${aleksis1})`}"></div>
          <div class="people-page__person__element people-page__person__element--tertiary" :style="{backgroundImage: `url(${aleksis3})`}"></div>
          <div class="people-page__person__element people-page__person__element--quaternary" :style="{backgroundImage: `url(${aleksis4})`}"></div>
          <h1 class="people-page__person__element people-page__person__element--name">
            aleksander
            <span class="people-page__person__element--name__inner">aleksander</span>
            <span class="people-page__person__element--name__inner">aleksander</span>
            <span class="people-page__person__element--name__inner">aleksander</span>
          </h1>
          <div class="people-page__person__element people-page__person__element--content">
            <h2 class="people-page__person__title">project & process lead</h2>
            <p class="people-page__person__description">enjoys leading the development both digital and physical products, through different process.</p>
          </div>
        </li>
        <li :class="`people-page__person people-page__person--three ${active == 2 ? 'people-page__person--active' : ''} ${active == 0 ? 'people-page__person--backwards' : 'people-page__person--forwards'}`">
          <div class="people-page__person__element people-page__person__element--secondary" :style="{backgroundImage: `url(${mikse2})`}"></div>
          <div class="people-page__person__element people-page__person__element--main" :style="{backgroundImage: `url(${mikse1})`}"></div>
          <div class="people-page__person__element people-page__person__element--tertiary" :style="{backgroundImage: `url(${mikse3})`}"></div>
          <div class="people-page__person__element people-page__person__element--quaternary" :style="{backgroundImage: `url(${mikse4})`}"></div>
          <h1 class="people-page__person__element people-page__person__element--name">
            mikkel
            <span class="people-page__person__element--name__inner">mikkel</span>
            <span class="people-page__person__element--name__inner">mikkel</span>
            <span class="people-page__person__element--name__inner">mikkel</span>
          </h1>
          <div class="people-page__person__element people-page__person__element--content">
            <h2 class="people-page__person__title">designer</h2>
            <p class="people-page__person__description">digital designer who thrives in designing both websites and applications alike.</p>
          </div>
        </li>
      </ul>
      <p class="people-page-more">explore my desperate soul <span class="intro__scroll__arrow link" @click="more">↓</span></p>
    </header>
    <nav :class="getNavClass()"><span @click="decrement" class="people-page-scroll people-page-nav__backwards link"><span>{{getPrevName()}}</span></span><span @click="increment" class="people-page-scroll link people-page-nav__forwards"><span>{{getNextName()}}</span></span></nav>
    <section class="people-page__more">
      <Frederik v-if="$route.params.name == 'frederik'" :trigger="trigger"/>
      <Mikkel v-if="$route.params.name == 'mikkel'" :trigger="trigger"/>
      <Aleksander v-if="$route.params.name == 'aleksander'" :trigger="trigger"/>
      <FrederikCases v-if="$route.params.name == 'frederik'" :trigger="trigger"/>
      <MikkelCases v-if="$route.params.name == 'mikkel'" :trigger="trigger"/>
      <AleksanderCases v-if="$route.params.name == 'aleksander'" :trigger="trigger"/>
    </section>
    <Footer />
  </article>
</template>

<script>
import Header from '@/components/Header/Header';
import IntroBox from '@/components/IntroBox/IntroBox';
import Footer from '@/components/Footer/Footer';
import './style.scss';
import mikse from '@/assets/mikse.png';
import aleksis from '@/assets/aleksis.png';

import frede1 from '@/assets/people/frede/1.jpg';
import frede2 from '@/assets/people/frede/2.jpg';
import frede3 from '@/assets/people/frede/3.jpg';

import mikse1 from '@/assets/people/mikse/1.jpg';
import mikse2 from '@/assets/people/mikse/2.jpg';
import mikse3 from '@/assets/people/mikse/3.jpg';
import mikse4 from '@/assets/people/mikse/4.jpg';

import aleksis1 from '@/assets/people/aleksis/1.jpg';
import aleksis2 from '@/assets/people/aleksis/2.jpg';
import aleksis3 from '@/assets/people/aleksis/3.jpg';
import aleksis4 from '@/assets/people/aleksis/4.jpg';

import SweetScroll from 'sweet-scroll';

import Frederik from '@/components/Frederik/Frederik';
import FrederikCases from '@/components/Cases/Frederik';
import Mikkel from '@/components/Mikkel/Mikkel';
import MikkelCases from '@/components/Cases/Mikkel';
import Aleksander from '@/components/Aleksander/Aleksander';
import AleksanderCases from '@/components/Cases/Aleksander';


import Office from '@/components/Office/Office';
import About from '@/components/About/About';
import People from '@/components/People/People';

import mouse from '@/utils/mouse';
import ismobile from '@/utils/ismobile';

export default {
  name: 'people-page',
  data() {
    let active = 0

    switch (this.$route.params.name) {
      case 'frederik':
          active = 0
        break;
      case 'aleksander':
          active = 1
        break;
      case 'mikkel':
          active = 2
        break;
    }

    return {
      wrapClass: 'people-page-wrap wrap wrap--bottom-left',
      frede1,
      frede2,
      frede3,
      mikse1,
      mikse2,
      mikse3,
      mikse4,
      mikse,
      aleksis1,
      aleksis2,
      aleksis3,
      aleksis4,
      active,
      scroller: '',
      activeNav: false,
    };
  },
  components: {
    Header,
    IntroBox,
    Footer,
    Frederik,
    FrederikCases,
    Mikkel,
    MikkelCases,
    Aleksander,
    AleksanderCases,
    Office,
    About,
    People,
  },
  mounted() {
    !ismobile() && mouse();
    if (!this.$route.params.name) {
      this.$router.push({ path: '/people/frederik/' })
    }

    setTimeout(() => {
      this.wrapClass = 'people-page-wrap wrap wrap--bottom-left loaded';
    }, 400);

    const is_safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    this.scroller = is_safari ? new SweetScroll({}, '.main-wrapper') : new SweetScroll({});

    window.addEventListener('keydown', this.key);
    window.addEventListener('scroll', this.onScroll);
  },
  methods: {
    getPrevName() {
      switch (this.active) {
        case 0:
            return 'mikkel'
          break;
        case 1:
            return 'frederik'
          break;
        case 2:
            return 'aleksander'
          break;
      }
    },
    getNextName() {
      switch (this.active) {
        case 0:
            return 'aleksander'
          break;
        case 1:
            return 'mikkel'
          break;
        case 2:
            return 'frederik'
          break;
      }
    },
    getNavClass() {
      if (this.activeNav) {
        return 'people-page-nav people-page-nav--active';
      } else {
        return 'people-page-nav';
      }
    },
    onScroll() {
      if (document.documentElement.scrollTop > 150) {
        this.activeNav = true;
      } else {
        this.activeNav = false;
      }
    },
    more() {
      this.scroller.to('.people-page__more');
    },
    lerp(a, b, n) {
        return (1 - n) * a + n * b;
    },
    shuffleArray(arr) {
      return arr.sort(() => Math.random() - 0.5);
    },
    lineEq(y2, y1, x2, x1, currentVal) {
      let m = (y2 - y1) / (x2 - x1);
      let b = y1 - m * x1;
      return m * currentVal + b;
    },
    key(e) {
      e.code == 'ArrowLeft' && this.decrement();
      e.code == 'ArrowRight' && this.increment();
    },
    increment() {
      this.scroller.to(0)
      if (this.active < 2) {
        this.active += 1;
      } else {
        this.active = 0;
      }
    },
    decrement() {
      this.scroller.to(0)
      if (this.active > 0) {
        this.active -= 1;
      } else {
        this.active = 2;
      }
    },
  },
  watch: {
    active: function(val) {
      switch (val) {
        case 0:
            this.$router.push({ path: '/people/frederik/' })
          break;
        case 1:
            this.$router.push({ path: '/people/aleksander/' })
          break;
        case 2:
            this.$router.push({ path: '/people/mikkel/' })
          break;
      }
    },
  },
  props: {
    trigger: Function,
  },
};
</script>



// WEBPACK FOOTER //
// src/containers/People/People.vue